/*
 * @Author: lvjinbin-at-631455864747 1367100043@qq.com
 * @Date: 2022-11-25 15:11:22
 * @LastEditors: your name
 * @LastEditTime: 2023-02-15 16:07:02
 * @Description: json 请求模块
 */

import axios from "axios";
import config from "./config";
import { captureMessage } from "@sentry/browser";

config.baseURL = "https://img.sharkfoto.com/sharkfoto/";

const service = axios.create(config);

service.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// 返回状态判断
service.interceptors.response.use(
  (res) => {
    if (res.status !== 200) {
      return {
        status: res.status,
        message: res.statusText,
        data: {},
      };
    } else {
      return {
        status: 200,
        message: "Request Success",
        data: res.data,
      };
    }
  },
  (error) => {
    captureMessage(error);
    console.error("Request Fail");
    return {
      status: -1,
      message: "Network Error, Please Try Again.",
      data: {},
    };
  }
);

export default service;
